import { render } from "./Subnav.vue?vue&type=template&id=70f57cb2"
import script from "./Subnav.vue?vue&type=script&lang=ts"
export * from "./Subnav.vue?vue&type=script&lang=ts"
script.render = render

export default script